import { Link } from "react-router-dom";
import { MessageCircle, Phone, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";

export function FinalCTA() {
  const site = useSite();
  return (
    <section className="relative overflow-hidden py-20 sm:py-28 lg:py-36" data-testid="final-cta-section">
      <div className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,black,transparent)]" aria-hidden="true" />
      <div className="absolute left-1/2 top-1/2 h-72 w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-rw-green/10 blur-[110px]" aria-hidden="true" />
      <div className="container-rw relative text-center">
        <Reveal>
          <h2 className="mx-auto max-w-4xl font-jakarta font-extrabold tracking-tight text-rw-text text-3xl sm:text-5xl lg:text-6xl leading-[1.05] text-balance" data-testid="final-cta-headline">
            Your next customer may already be <span className="text-rw-green">searching.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base sm:text-lg text-rw-muted">
            Let's make sure they find you.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/contact" data-testid="final-cta-audit"
              className="inline-flex items-center gap-2 rounded-full bg-rw-green px-8 py-4 text-sm font-semibold text-rw-bg transition-all hover:bg-rw-green2 hover:-translate-y-0.5 glow-green">
              Get SEO Audit <ArrowUpRight size={16} />
            </Link>
            <a href={site.waLink} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp"
              className="inline-flex items-center gap-2 rounded-full border border-rw-border2 px-8 py-4 text-sm font-semibold text-rw-text transition-all hover:border-rw-green/60 hover:text-rw-green">
              <MessageCircle size={16} className="text-rw-green" /> WhatsApp Us
            </a>
            <a href={site.telLink} data-testid="final-cta-call"
              className="inline-flex items-center gap-2 rounded-full border border-rw-border2 px-8 py-4 text-sm font-semibold text-rw-text transition-all hover:border-rw-blue/60 hover:text-rw-blue">
              <Phone size={16} className="text-rw-blue" /> Call Now
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
